import React, { PropsWithChildren } from 'react'
import { Spinner } from '@notino/react-styleguide'

// styles
import * as SC from './OverlayLoadingStyles'

type Props = PropsWithChildren<{
	inertWhileLoading?: boolean
	isLoading?: boolean
	className?: string
}>

const OverlayLoading = (props: Props) => {
	const { isLoading = false, className, children, inertWhileLoading = true } = props

	return (
		<SC.OverlayLoadingWrapper className={className} {...(isLoading && inertWhileLoading ? { inert: '' } : undefined)}>
			{isLoading && (
				<SC.SpinnerWrapper>
					<Spinner size={24} color={'icon.primary'} />
				</SC.SpinnerWrapper>
			)}
			<SC.OverlayLoadingContent $isLoading={isLoading}>{children}</SC.OverlayLoadingContent>
		</SC.OverlayLoadingWrapper>
	)
}

export default OverlayLoading
